export default __webpack_public_path__ + "static/media/space-object-b.23e29a8f.svg";